<template>
  <div>
    <!-- 塾検索フォーム -->
    <v-customer-search-form />

    <!-- 塾検索結果表示エリア -->
    <v-container class="py-0" fluid v-if="isSearched">
      <!-- 塾情報 -->
      <v-form
        ref="customer-form"
        :value="customerValid"
        lazy-validation
      >
        <v-request-customer-form/>
      </v-form>

      <!-- 登録済教室一覧 -->
      <v-registered-classroom-table/>

      <!-- 教室情報 -->
      <v-form
        ref="classroom-form"
        :value="classroomValid"
        lazy-validation
      >
        <!-- 教室情報フォーム -->
        <template v-for="index in classrooms.length">
          <v-request-classroom-form :key="index" :index="index"/>
        </template>
      </v-form>

      <v-row>
        <v-btn class="mt-4 ml-3 mr-4" color="secondary" :disabled="disabledAddClassroom" @click="addClassroom">
          教室追加
        </v-btn>
      </v-row>
    <p class="mb-0 mt-2 attetion">※一度に申し込める教室数は10件までです。</p>

    </v-container>
  </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import VCustomerSearchForm from '@/components/molecules/CustomerSearchForm'
import VRegisteredClassroomTable from '@/components/molecules/RegisteredClassroomTable'
import VRequestCustomerForm from '@/components/organizms/RequestCustomerForm'
import VRequestClassroomForm from '@/components/organizms/RequestClassroomForm'

export default {
  components: {
    VCustomerSearchForm,
    VRegisteredClassroomTable,
    VRequestCustomerForm,
    VRequestClassroomForm,
  },

  props: {},

  computed: {
    ...mapState('enrollment',[
      'customerValid',
      'classrooms',
      'classroomValid',
    ]),
    ...mapGetters('enrollment',[
      'isSearched',
      'disabledAddClassroom'
    ]),
  },

  methods: {
    ...mapMutations('enrollment', [
      'setCustomerPayload',
      'setRegisteredClassrooms',
      'addClassroom',
    ]),
  },
}
</script>

<style lang="stylus" scoped>
  .attetion
    font-size 12px
</style>
